module.exports = __webpack_public_path__ + "static/media/gorra (13).f8bbd354.png";